const DIFF = 'diff';
const SLIDER = 'slider';
const FADE = 'fade';

export const COMPARE_METHODS = {DIFF, SLIDER, FADE};

export const COMPARE_TYPES = {
  RESULT: 'result',
  MOSAIC: 'basemap',
  SCENE: 'item',
};
